var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-group', {
    staticClass: "checkbox-group-input",
    attrs: {
      "label": _vm.label,
      "errors": _vm.internalErrors
    },
    on: {
      "focus": _vm.focus
    }
  }, _vm._l((_vm.options), function(option, index) {
    return _c('label', {
      staticClass: "checkbox-group-input__option",
      class: {
        'uk-margin-small-left': _vm.inline && !_vm.isFirstItem(index),
          'checkbox-group-input__option--inline': _vm.inline,
          'checkbox-group-input__option--block': !_vm.inline
      }
    }, [_c('input', {
      staticClass: "uk-checkbox",
      attrs: {
        "name": _vm.groupName,
        "type": "checkbox",
        "disabled": _vm.disabled
      },
      domProps: {
        "value": option.value,
        "checked": _vm.isSelected(option.value)
      },
      on: {
        "change": _vm.onInput
      }
    }), _vm._v("\n    " + _vm._s(option.label) + "\n  ")])
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-370499e9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/CheckboxGroupInput.vue
// module id = 1931
// module chunks = 0